import useMutation from "src/hooks/useMutation";

function useProviderUpdate(id) {
  return useMutation({
    path: `/api/v1/providers/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/providers`,
      shouldRevalidate: true,
    },
  });
}

export default useProviderUpdate;
